import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import {
  CommonSelect,
  Input,
  LoadingButton,
} from "../../../../Components/header/form";
import {
  fetchCountryListApi,
  fetchCategoriesListApi,
} from "../../../../services/common/index";
import { registerUserApi } from "../../../../services/auth";
import multipartDataHelper, { printFormData } from "../../../../utils/sendMultipartDataHelper";
import { useNavigate } from "react-router";
import { toastMessage } from "../../../../utils/toastMessage";
import { setToken } from "../../../../config/AxiosInstance";
import {
  allowAlphabetsWithSpace,
  areMandatoryFieldsFilled,
} from "../../../../utils/inputValueValidation";
import { isTrue } from "../../../../utils/commonHelper";
import { addional_checkbox, gray_checkbox } from "../../../../assets";
import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { socket } from "../../../../utils/socket";

const AdditionalInfo = ({
  registrationData,
  setLoading,
  loading,
  image,
  registrationStepperHandler,
}) => {
  const navigate = useNavigate();
  const [userAdditionalData, setUserAdditionalData] = useState({
    terms_condition: true,
  });
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [whatsappPhone, setWhatsappPhone] = useState({
    whatsappDialCode: "",
    whatsappNumber: "",
    whatsappCompleteMobile: "+93",
  });
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);

  //   Fetching Country List
  const fetchCountryList = async () => {
    try {
      const { data } = await fetchCountryListApi();
      const { success, data: response } = data;
      if (success) {
        setCountryList(
          response?.map((data) => ({
            label: data?.name,
            value: data?.id,
          }))
        );
      } else {
        setCountryList([]);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  //   Fetching Category List
  const fetchCategoryList = async () => {
    try {
      const { data } = await fetchCategoriesListApi();
      const { success, data: response } = data;
      if (success) {
        setCategoryList(response);
      } else {
        setCategoryList([]);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  //   Handle Change
  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === "profession") {
      setUserAdditionalData({
        ...userAdditionalData,
        [name]: allowAlphabetsWithSpace(value),
      });
    } else if (name === "sameAsRegistered") {
      setUserAdditionalData({
        ...userAdditionalData,
        [name]: checked,
      });
      setWhatsappPhone({
        whatsappDialCode: "",
        whatsappNumber: "",
        whatsappCompleteMobile: "",
        whatsappCountry: "",
        whatsappIso2: "",
      });
    } else if (name === "terms_condition") {
      setUserAdditionalData({
        ...userAdditionalData,
        [name]: checked,
      });
    } else if (name === "state" || name === "city") {
      setUserAdditionalData({
        ...userAdditionalData,
        [name]: allowAlphabetsWithSpace(value),
      });
    } else {
      setUserAdditionalData({ ...userAdditionalData, [name]: value });
    }
  };

  //   Handle Phone Change
  const handlePhoneChange = (phone, country) => {
    const phoneWithoutCountryCode = phone.replace(country?.dialCode, "");
    setWhatsappPhone({
      whatsappNumber: phoneWithoutCountryCode,
      whatsappCompleteMobile:
        `+${country?.dialCode}${phoneWithoutCountryCode}` || "+1",
      whatsappDialCode: `+${country?.dialCode}`,
    });
  };

  //   Selected Category
  const handleSelectedCategory = (category) => {
    setSelectedCategory((prev) => {
      const tempCategory = [...prev];
      const index = tempCategory.findIndex((d) => d?._id === category?._id);

      if (index !== -1) {
        tempCategory.splice(index, 1);
      } else {
        tempCategory.push(category);
      }

      return tempCategory;
    });
  };

  //   Handle Select All
  const handleSelectAllChange = (e) => {
    const { checked } = e.target;
    setSelectedCategory(
      checked && Array.isArray(categoryList) ? [...categoryList] : []
    );
  };

  // Handle Create User
  const handleCreateUser = async (e) => {
    e.preventDefault();
    try {
      const requestData = {
        ...registrationData,
        country: selectedCountry?.label,
        countryId: selectedCountry?.value,
        city: userAdditionalData?.city,
        // state: userAdditionalData?.state,
        interestedCategories: selectedCategory?.map((data) => data?._id),
        sameAsRegistered: isTrue(userAdditionalData?.sameAsRegistered),
      };
      console.log('requestData', requestData)
      if (!isTrue(userAdditionalData?.sameAsRegistered)) {
        const { whatsappCompleteMobile, ...restData } = whatsappPhone;
        const { terms_condition, ...restAdditionalData } = userAdditionalData;
        Object.assign(requestData, restData, restAdditionalData);
      }
      const formData = new FormData();
      if (image && image?.name) {
        formData.append("profile", image);
      }
      console.log('printFormData(formData)', printFormData(formData))
      multipartDataHelper(formData, requestData, false);
      const { data } = await registerUserApi(formData);
      const { success, message, data: response } = data;
      setToken(response?.token); // Setting Token In Local Storage
      if (success) {
        socket.auth = {
          token: response?.token
        }
        socket.connect();
        navigate("/joingroup");
      }

      toastMessage(message, success ? "success" : "error", "createUser");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };

  const requiredFields = [
    "country",
    // "state",
    "city",
    "whatsappNumber",
    "interestedCategories",
    "terms_condition",
  ];

  const formFields = {
    country: selectedCountry?.label,
    // state: userAdditionalData?.state,
    city: userAdditionalData?.city,
    whatsappNumber: whatsappPhone?.whatsappNumber,
    interestedCategories: selectedCategory,
    terms_condition: userAdditionalData?.terms_condition,
  };

  useEffect(() => {
    fetchCountryList();
    fetchCategoryList();
  }, []);

  useEffect(() => {
    if (isTrue(userAdditionalData?.sameAsRegistered)) {
      setWhatsappPhone({
        whatsappDialCode: registrationData?.dialCode || "+1",
        whatsappNumber: registrationData?.number,
        whatsappCompleteMobile: `${registrationData?.dialCode}${registrationData?.number}`,
      });
    }
  }, [userAdditionalData?.sameAsRegistered]);

  return (
    <div className="wrap_profile">
      <h2>
        <span className="title_backarrow">
          <IoIosArrowBack
            onClick={() =>
              registrationStepperHandler(
                "personalInfo",
                registrationData,
                image
              )
            }
          />
        </span>
        Additional Information
      </h2>

      <form className="additional-form">
        <div className="form_field_wrap additional_contacts">
          <div className="form-group">
            <label className="label" htmlFor="name">
              Whatsapp number *
            </label>
            <div className="whatapp_no phone_number">
              <PhoneInput
                // country={userAdditionalData?.countryCode === "us" ? "us" : "ca"}
                disabled={isTrue(userAdditionalData?.sameAsRegistered)}
                value={whatsappPhone?.whatsappCompleteMobile}
                enableSearch={true}
                countryCodeEditable={true}
                onChange={handlePhoneChange}
                className="input form-control"
              />
            </div>
          </div>

          <div className="form-group">
            <Input
              type="text"
              label="Profession"
              id="profession"
              name="profession"
              value={userAdditionalData?.profession || ""}
              onChange={handleChange}
              className="input form-control"
              placeholder="Enter profession"
            />
          </div>
        </div>

        <div className="form-group additional_checkbox">
          <input
            type="checkbox"
            name="sameAsRegistered"
            value={userAdditionalData?.sameAsRegistered}
            onChange={handleChange}
          />
          <label className="label">Same As Registered Number</label>
        </div>

        <div className="form_field_wrap">
          <div className="form-group">
            <CommonSelect
              label="Country"
              required
              options={countryList}
              placeholder="Select Country"
              value={selectedCountry}
              onChange={(country) => {
                setSelectedCountry(country);
                setUserAdditionalData({
                  ...userAdditionalData,
                  state: "",
                  city: "",
                });
              }}
              isSearchable
              isMulti={false}
            />
          </div>

          {/* <div className="form-group">
            <Input
              required
              type="text"
              label="State"
              id="state"
              name="state"
              value={userAdditionalData?.state || ""}
              onChange={handleChange}
              className="input form-control"
              placeholder="Enter State Name"
            />
          </div> */}

          <div className="form-group">
            <Input
              required
              type="text"
              label="City"
              id="city"
              name="city"
              value={userAdditionalData?.city || ""}
              onChange={handleChange}
              className="input form-control"
              placeholder="Enter City Name"
            />
          </div>
        </div>

        <div className="form_field_wrap">
          <div className="form-group">
            <Input
              type="text"
              label="Instagram Link"
              id="instagram"
              name="instagram"
              value={userAdditionalData?.instagram || ""}
              onChange={handleChange}
              className="input form-control"
              placeholder="Enter Instagram link"
            />
          </div>

          <div className="form-group">
            <Input
              label="Facebook Link"
              type="text"
              id="facebook"
              name="facebook"
              value={userAdditionalData?.facebook || ""}
              onChange={handleChange}
              className="input form-control"
              placeholder="Enter facebook link"
            />
          </div>
        </div>

        <div className="form_field_wrap">
          <div className="form-group">
            <Input
              label="X Link"
              type="text"
              id="x"
              name="x"
              value={userAdditionalData?.x || ""}
              onChange={handleChange}
              className="input form-control"
              placeholder="Enter X link"
            />
          </div>
        </div>

        <div className="itrest_categry">
          <b>Interested Category *</b>
          {/* <form action=""> */}
          &nbsp;
          <label htmlFor="vehicle1">
            {" "}
            <input
              type="checkbox"
              id="category"
              name="category"
              checked={
                categoryList.length > 0 &&
                categoryList.every((category) =>
                  selectedCategory.some(
                    (selected) => selected._id === category._id
                  )
                )
              }
              onChange={handleSelectAllChange}
            />{" "}
            Select All
          </label>
          {/* </form> */}
        </div>
        <i>(Select Atleast One Category)</i>

        <div className="btn_group">
          {categoryList?.map((data) => {
            const isActive =
              selectedCategory.length > 0 &&
              selectedCategory?.some((d) => d?._id === data?._id);
            return (
              <button
                type="button"
                key={data?._id}
                className={`btn btns ${isActive ? " btn1 active" : ""}`}
                onClick={() => handleSelectedCategory(data)}
              >
                {data?.name}
              </button>
            );
          })}
        </div>
        <div className="term_condition">
          <span
            onClick={() =>
              setUserAdditionalData({
                ...userAdditionalData,
                terms_condition: !userAdditionalData?.terms_condition,
              })
            }
          >
            {userAdditionalData?.terms_condition ? (
              <img src={addional_checkbox} />
            ) : (
              <img src={gray_checkbox} />
            )}
          </span>
          <p>
            By tapping here you agree to our{" "}
            <Link onClick={() => navigate("/terms")}>Terms and Conditions</Link>
            &nbsp; & &nbsp;
            <Link onClick={() => navigate("/privacy")}>Privacy Policy.</Link>
          </p>
        </div>
        <LoadingButton
          loading={loading}
          isDisabled={
            !areMandatoryFieldsFilled(formFields, requiredFields) ||
            !userAdditionalData?.terms_condition
          }
          onClick={handleCreateUser}
          className={`button next-button signup ${
            !areMandatoryFieldsFilled(formFields, requiredFields) ||
            !userAdditionalData?.terms_condition
              ? "cstm_disabled_btn"
              : ""
          }`}
        >
          Sign Up
        </LoadingButton>
      </form>
    </div>
  );
};

export default AdditionalInfo;
